import { useTranslation } from 'react-i18next'

export const DocumentMeta = () => {
  const { t } = useTranslation()

  return (
    <>
      <title>{t('meta.title')}</title>
      <meta content={t('meta.description')} name="description" />
    </>
  )
}
